import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";



// For Get The Next Page 
const getNextPostsEndpoint  = (args)=>`${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}&pagingToken=${args.hasNext}` ; 

 export const getNextPostsAPI = createAsyncThunk('group/hasNextGroup' , async (args , thunkaPI)=>{
    const {rejectWithValue} = thunkaPI ; 
    try{
        const response = await axios.get(getNextPostsEndpoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ;
    }
})


// For Get All Post Of Group (Next)
const getPostsOfGroupNextEndPoint = (args)=> `${DomainName}/group/feed?userAccessToken=${args.userToken}&until=${args.until}&groupId=${args.groupId}&paginToken=${args.hasNext}` ; 

export const getAllPostsOfGroupNextAPI = createAsyncThunk('group/allPostsNext' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getPostsOfGroupNextEndPoint(args) , {
            headers : {
                token :args.token
            }
        })
        console.log(response.data)
        return response.data.data
    }catch(error){
        return rejectWithValue(error)
    }
})


// For Get All Post Of Group
const getPostsOfGroupEndPoint = (args)=> `${DomainName}/group/feed?userAccessToken=${args.userToken}&groupId=${args.groupId}` ; 

export const getAllPostsOfGroupAPI = createAsyncThunk('group/allPosts' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getPostsOfGroupEndPoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data.data
    }catch(error){
        return rejectWithValue(error)
    }
})

// For Post On Group
const postOnGroupEndPoint =(args)=> `${DomainName}/group/createPost?userAccessToken=${args.userToken}` ;

export const postOnGroupAPI = createAsyncThunk('group/post' ,async (args , thunkAPI)=>{
    console.log(args)
    const {rejectWithValue} = thunkAPI ; 
    try{
        await axios.post(postOnGroupEndPoint(args ) , 
            args.data
         , {
            headers : {
                token : args.token
            }
        })
        
        return args.groupId + 1
    }catch(error){
        return rejectWithValue(error) ;
    }
})


// For Get The Next ALl Group
const getAllGroupsNextEndPoint = (args)=>`${DomainName}/group/gr?userAccessToken=${args.userToken}&limit=20&pagingToken=${args.hasNextGroup}`;

export const getAllGroupsNextAPI = createAsyncThunk('group/getAllNext' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAllGroupsNextEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data
    }catch(error){
        return rejectWithValue(error)
    }
})

// For Get All Groups 
const getAllGroupsEndPoint = (args)=>`${DomainName}/group/gr?userAccessToken=${args.userToken}&limit=20`;
export const getAllGroupsAPI = createAsyncThunk('group/getAll' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAllGroupsEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data
    }catch(error){
        return rejectWithValue(error)
    }
})


// For Initial State 
const initialState = {
    allGroups : [] , 
    status : STATUS.IDLE , 
    postsOfGroupStatus : STATUS.IDLE , 
    postsOfGroupData : [] , 
    specifcGroupPosts : [] , 
    specificGroupsPostsStatus : STATUS.IDLE , 
    hasNextGroup : "" , 
    hasNextPost : "" ,
    untilNextPost : ''
}

const GroupSlice = createSlice({
    name : "group" , 
    initialState , 
    reducers : {
        stopNext : (state )=>{
            state.status = STATUS.IDLE ;
        }
    }, extraReducers : (builder)=>{
        builder
        // For Get All Groups
        .addCase(getAllGroupsAPI.fulfilled , (state , action)=>{
            state.allGroups = action.payload?.groups ;
            state.status = STATUS.SUCCESS ; 
            state.hasNextGroup = action.payload?.paging?.next !== undefined ? action.payload.paging.cursors.after : ""  ; 

        })
        .addCase(getAllGroupsAPI.pending , (state  )=>{
            state.status = STATUS.LOADDING
        })
        .addCase(getAllGroupsAPI.rejected , (state )=>{
            state.status = STATUS.ERROR
        })
        
        // For Get All Posts Of Specific Group
        .addCase(getAllPostsOfGroupAPI.fulfilled ,(state ,action)=>{
            state.postsOfGroupData = action.payload.posts ; 
            state.postsOfGroupStatus = STATUS.SUCCESS
            state.hasNextPost = action.payload?.nextPageToken ; 
            state.untilNextPost = action.payload?.nextUntil ;
        })
        .addCase(getAllPostsOfGroupAPI.pending ,(state )=>{
            state.postsOfGroupStatus = STATUS.LOADDING
        })
        .addCase(getAllPostsOfGroupAPI.rejected ,(state )=>{
            state.postsOfGroupStatus = STATUS.ERROR
        })
        
        // For Get The Next Posts Of Group 
        .addCase(getAllPostsOfGroupNextAPI.fulfilled , (state , action)=>{
            state.postsOfGroupData.push(...action.payload.posts) ;
            state.postsOfGroupStatus = STATUS.SUCCESS  ;
            state.hasNextPost = action.payload?.nextPageToken ; 
            state.untilNextPost = action.payload?.nextUntil ;
        })
        .addCase(getAllPostsOfGroupNextAPI.pending , (state , action)=>{
            state.postsOfGroupStatus = STATUS.LOADDING  ;
        })

        // For Post On Group
        .addCase(postOnGroupAPI.fulfilled , (_ , action)=>{
            toast.success(`Post On Group ${action.payload} Done`)
        })
        // For the Next Group
        .addCase(getAllGroupsNextAPI.fulfilled , (state , action)=>{
            state.allGroups.push(...action.payload.groups) ; 
            state.hasNextGroup = action.payload?.paging?.next !== undefined ? action.payload.paging.cursors.after : ""  ; 
            state.status = state.status === STATUS.IDLE || state.hasNextGroup === '' ? STATUS.SUCCESS : STATUS.LOADDING
        })
        .addCase(getAllGroupsNextAPI.pending , (state , action)=>{ 
            // state.status = STATUS.LOADDING
        })
    }
})

export default GroupSlice.reducer ; 

export const getAllGroupsInfo = state => state.GroupSlice ; 

export const getHasNextGroup = state => state.GroupSlice.hasNextGroup ;

export const getHasNextGroupPosts = state => state.GroupSlice.hasNextPost ;

export const getHasNextUntilGroupPosts = state => state.GroupSlice.untilNextPost

export const getAllPostsOfGroupInfo = state => state.GroupSlice ; 

export const {stopNext} = GroupSlice.actions ; 

